import { render } from "./PWAPrompt.vue?vue&type=template&id=5b087e4e&scoped=true"
import script from "./PWAPrompt.vue?vue&type=script&lang=js"
export * from "./PWAPrompt.vue?vue&type=script&lang=js"

import "@/components/PWAPrompt/style.scss?vue&type=style&index=0&id=5b087e4e&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b087e4e"]])

export default __exports__